import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import { BeatLoader } from 'react-spinners';
import {QRCodeSVG} from 'qrcode.react';

// set up amplify config
import { Amplify } from 'aws-amplify';
import { signIn, confirmSignIn, updateMFAPreference  } from 'aws-amplify/auth';

import awsconfig from '../../../src/aws-exports';

import { useNavigate } from 'react-router-dom';

import '../../../src/styles/login.css';

// Notification
import Notification from '../Notification';

import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import { isUserRegistered } from '../../redux/actions/checkUserRegister';

import Footer from '../Footer';
import SideBar from '../SideBar';


Amplify.configure(awsconfig);

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [showSignup, setShowSignup] = useState(false);
  const [showResetPass, setShowResetPass] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isMFA, setIsMFA] = useState(false);
  const [MFAconfirm, setMFAconfirm] = useState(false);
  const [loadingVerificationCode, setLoadingVerificationcode] = useState(false);
  const [loadingSignIn, setLoadingSignIn] = useState(false);
 
  const [isTOTPsetUpRequired, setIsTOTPsetUpRequired] = useState(false);
  const [TOTPsetupCode, setTOTPsetupCode] = useState('');

  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
 
  const checkUser = useSelector((state => state.checkUser));

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  }

  const handlePasswordChange = (e) => {
      setPassword(e.target.value);
  }
 
  // Sign up modal
  const handleCloseSignup = () => {
    setShowSignup(false);    
  } 

  const handleShowSignup = () => {   
    setShowSignup(true);    
  }

 // Forgote Password modal
  const handleCloseResetPass = () => {
    setShowResetPass(false);    
  } 

  const handleShowResetPass = () => {   
    setShowResetPass(true);    
  }

  
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const confirmHandleLogin = async() => {
    try {
      const responseConfirmSignIn = await confirmSignIn({
        challengeResponse: code
      });
      console.log('responseConfirmSignIn:', responseConfirmSignIn);

      setLoadingSignIn(true);
      setLoadingSignIn(false);
      setMFAconfirm(true);
      dispatch(isUserRegistered(email));
    } catch (error) {
      console.error('Error confirming sign in:', error);

      if (error.message === 'Invalid session for the user, session is expired.') {
        let errorMsg = 'session is expired, please login again.';
        setErrorMsg(errorMsg);
        setIsMFA(false);
      }
      else if (error.message === 'Invalid code received for user') 
      {
        let errorMsg = 'Invalid code received. Please enter the correct code.';
        setErrorMsg(errorMsg);
       
        setLoadingSignIn(false);   
      }

      else {
      let errorMsg = 'Error confirming sign in. Please try again.';
      setErrorMsg(errorMsg);
      setIsMFA(false);
      setLoadingSignIn(false);
  }
  }
  }


  // rap the definition of 'handleCancel' in its own useCallback() Hook to prevent it from being recreated on every render
  const handleCancel = useCallback(() => {
   setIsMFA(false);
   setEmail('');
   setPassword('');
   setLoadingVerificationcode(false);
   setLoadingSignIn(false);
   localStorage.clear();
   navigate('/');
  }, [navigate]);


  const isSmallScreen = window.innerWidth < 600;

  const verifyTOTP = async () => {
    try {
      setLoadingSignIn(true);
      await confirmSignIn({
        challengeResponse: code
      });
     
      // set TOTP as the preferred MFA method.
      await updateMFAPreference({ totp: 'PREFERRED' });

      setLoadingSignIn(false);
      setMFAconfirm(true);
      dispatch(isUserRegistered(email));

    } catch (error) {
      console.error('Error verifying TOTP:', error);
      setLoadingSignIn(false);

      if (error.message === 'Invalid session for the user, session is expired.') {
        let errorMsg = 'session is expired, please login again.';
        setErrorMsg(errorMsg);

        setIsMFA(false);
      }

      else {
       setErrorMsg(error.message);  
      } 
    }
  }

  const handleTOTPSetup = (secretCode) => {       
      try {
    
        setTOTPsetupCode(secretCode);
        setIsTOTPsetUpRequired(false);
      } 
      catch (error) {
      console.error('Error setting up TOTP:', error);
      setErrorMsg(errorMsg);

    }
  };

  const handleSignin = async () => {
    setSubmitted(true);
    try{
      setLoadingVerificationcode(true);
      const { isSignedIn, nextStep } = await signIn({ username: email, password });  
      console.log('isSignedIn:', isSignedIn);
      console.log('nextStep:', nextStep);

      setErrorMsg(errorMsg);

      setLoadingVerificationcode(false);

      if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_TOTP_CODE') {
        setIsMFA(true);
      }

      // check if first time TOTP setup required
      if (nextStep.signInStep === 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP') {
        setIsTOTPsetUpRequired(true);
        const secretcode = nextStep.totpSetupDetails?.sharedSecret;
        console.log('secretcode:', secretcode);
        handleTOTPSetup(secretcode); // set up TOTP (Authenticator app MFA)
      }

      if (nextStep.signInStep === 'CONFIRM_SIGN_UP') {
        let errorMsg = 'You can not login because sign up is pending. Please Sign up first.';
        setErrorMsg(errorMsg);
      }
    } catch (error) {
        console.log(error.message)
      setLoadingVerificationcode(false);
      if (error.message === 'User is not confirmed.') {
        let errorMsg = 'You can not login because user verification is pending. Please contact Art of Logic support (support@artoflogictech.com) to confirm verification.';
        setErrorMsg(errorMsg);
      }
      else if (error.message === 'User does not exist.') {
        let errorMsg = `${email} does not exist. Please Sign up to create a user.`;
        setErrorMsg(errorMsg);       
      }
      else if (error.message === 'Custom auth lambda trigger is not configured for the user pool.') {
        let errorMsg = "Password can't be blank";
        setErrorMsg(errorMsg);
      }
      else if (error.message === 'Invalid session for the user, session can only be used once.') {
      
        setIsMFA(false);
      }
      else if (error.message === 'There is already a signed in user.') {
        setIsMFA(true);
      }
      else {
        let errorMsg = error.message;
        setErrorMsg(errorMsg);
      }
    }
  }
  
  
  useEffect(() => {
    const fetch_user_check = window.localStorage.getItem('fetch_user_check');   
    
    if (submitted && MFAconfirm && fetch_user_check === 'true') {
      // console.log(`Line 246 user successfully logs in`);
      // check if the email registered to the user database   
      // if (checkUser.response === 'true') {

        // Sucessful login
        localStorage.setItem('email', email);
        // check if in deveopment or production environment
        const isProduction = window.location.hostname !== "192.168.1.32";
        // Set the cookie to be shared acorss subdomains
        document.cookie = `email=${email}; path=/; ${isProduction ? "domain=.artoflogic.ai; Secure; SameSite=None" : "SameSite=Lax"}`;      
      
        navigate("/");
        // }
      
      // else {
      //   let errorMsg = "You can not continue now because this email is not yet registered with the SAMURAI Analytic services. Please contact Art of Logic support (support@artoflogictech.com) to register your email.";
      //   setErrorMsg(errorMsg);
      //   console.log(`Error message: ${errorMsg}`);
      //   // set SHOGUN to false
      //   localStorage.setItem('SHOGUN', 'false');
      //   // set RONIN to false
      //   localStorage.setItem('RONIN', 'false');
      //   handleCancel();
      // } 
    }
    
  }, [navigate, checkUser, MFAconfirm, submitted, email, handleCancel]);

  return (
   <>
      {
        !isSmallScreen && 
        <div>
            <SideBar />
        </div>
      }

    <div id='login-container'>
       <Card  id='input-card'>
        <Card.Body>
        <Card.Title style={{ textAlign: 'center'}}><span className='card-title'>Get started!</span></Card.Title>        
        <input size="80%" className='input-box'
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={handleEmailChange}
        />
       
        <input className='input-box'
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={handlePasswordChange}
        />

        <button className='signin-btn' variant='secondary' size={ isSmallScreen ? 'sm' : 'md' } onClick={handleSignin}>Sign in</button>
       

        { isTOTPsetUpRequired &&
          <button onClick={handleTOTPSetup}>Set up TOTP</button>          
        }
      

        {!isTOTPsetUpRequired && TOTPsetupCode &&
          <div id='qrcode-text'>          
            <span style={{ opacity: '0.95' }}>Scan the QR code with your authenticator app.</span>
            
            <div className='qrcode-container'>
              <QRCodeSVG value={`otpauth://totp/ArtofLogic:${email}?secret=${TOTPsetupCode}&issuer=AWSCognito`} />
            </div>
            
            <input
              type="text"
              id='input-box-mfa'
              placeholder="Enter authenticator code "
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <button className='signin-submit-code-btn' variant='secondary' onClick={verifyTOTP}>Submit code</button>
           
          </div>
        }
       
        { loadingVerificationCode ?
          <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
            <BeatLoader size={5} color="#36d7b7"/>
          </div> :
          <div style={{ marginTop: '0.0em', height: '1.5em' }}>
          
        </div> 
        }       

        {isMFA && (
        <div>
          <div>
          <div id='signin-mfa-text'>              
              Please enter the code from your registered authenticator app. Once the code is entered, click on Submit Code button.
            </div>
            <input  id='input-box-mfa'          
              type="text"
              placeholder="Enter authenticator code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />           
            <button className='signin-submit-code-btn' disabled={loadingSignIn} onClick={confirmHandleLogin}>Submit code</button> 
           
            { loadingSignIn ?
           <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
            <BeatLoader size={5} color="#36d7b7"/>
            </div> :
            <div style={{ marginTop: '0.0em', height: '1.5em' }}>
         
            </div> 
            }

          </div>
         
         
        </div>
      )}
      
        <div id='bottom-text'>
          <span style={{ color: 'white' }}>Dont't have an account ?</span>

          <button className='signup-btn' onClick={() => handleShowSignup()}>
            Sign up
          </button>
          <br></br>
        
          <Button variant='text' id='bottom-btn' style={{ color: 'orange', padding: '0' }} onClick={() => handleShowResetPass()}>
            Forgot password ?
          </Button>
        
        </div>
        <div id='bottom-text' style={{ color: 'lightgray', fontSize: '0.74rem' }}>*If you lost your authenticator device, please contact Art of Logic.</div>
        
        </Card.Body>
          <button className='signin-cancel-btn' onClick={() => handleCancel()}>
            Cancel
          </button>
    </Card>    

    {/* modal to view Signup modal*/}

    <Modal centered show={showSignup} onHide={handleCloseSignup} className='signup-modal'>
        <Modal.Header className='modal-color-header'>
          <div className='signup-modal-header-container'>
            <Modal.Title ><span className='signup-modal-title-text'>Create a new account</span></Modal.Title>
              <button className="custom-close" onClick={handleCloseSignup}>X</button>
          </div>
        </Modal.Header>
        <Modal.Body className='modal-color'>
          <SignUp  onClose={handleCloseSignup} setSuccessMsg={setSuccessMsg}/>
        </Modal.Body>
      </Modal>

      
    {/* modal to view Forgot Password modal*/}

    <Modal centered show={showResetPass} onHide={handleCloseResetPass} >
        <Modal.Header  className='modal-color-header'>
        <div className='signup-modal-header-container'>
          <Modal.Title style={{ fontSize: '1em' }}>Reset your password</Modal.Title>
          <button className="custom-close" onClick={handleCloseResetPass}>X</button>
        </div>
        </Modal.Header>
        <Modal.Body className='modal-color'>
          <ForgotPassword  username={email} onClose={handleCloseResetPass}  />
        </Modal.Body>
      </Modal>   

    </div>
    <div className='signin-footer-container' >
      <Footer />
    </div>
    { errorMsg && <Notification message={errorMsg} type="error" /> }
    { successMsg && <Notification message={successMsg} type="success" /> }

    </>
    
  );
};

 

export default LoginPage;
